<template>
  <div class="header-navigation">
    <div class="navbar d-flex">
      <v-tabs
        v-model="tab"
        class="hide-vertical-line"
        show-arrows
        color="primary"
      >
        <v-tab
          value="/MyOrders"
          @click="onTabClick('/MyOrders')"
        >
          {{ $t('My Orders') }}
        </v-tab>
        <v-tab
          value="/MyPatients"
          @click="onTabClick('/MyPatients')"
        >
          {{ $t('My Patients') }}
        </v-tab>
      </v-tabs>
      <UserMenu />
    </div>
    <div>
      <v-divider class="mb-6" />
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { usePhysiciansStore } from '@/stores/physicians'
import { useProfileStore } from '@/stores/profile'
import UserMenu from '@/components/navigation/UserMenu.vue'

const route = useRoute()
const router = useRouter()
const physiciansStore = usePhysiciansStore()
const profileStore = useProfileStore()

const userProfile = computed(() => profileStore.profile)

const tab = computed({
  get: () => getTabFromRouteName(route.name as string),
  set: (val: string) => {
    if (val !== route.path) {
      router.push(val)
    }
  }
})

function getTabFromRouteName(name: string | undefined) {
  if (['Create Patient', 'Edit Patient', 'My Patients'].includes(name || '')) {
    return '/MyPatients'
  }
  return '/MyOrders'
}

function onTabClick(tabValue: string) {
  if (tabValue) {
    router.push(tabValue)
  }
}
</script>
<style lang="scss">
.header-navigation {
  font-size: 1.125rem !important;

  .navbar {
    @media #{map.get($display-breakpoints, 'xs-only')} {
      flex-direction: column-reverse;
      flex-basis: 100%;
    }
  }

  .activeTab {
    .v-tabs-slider-wrapper {
      height: 0 !important;
    }
  }

  .v-divider {
    width: calc(100% - 1rem);
    margin-left: 1rem;
  }

  .v-tab {
    color: rgb(var(--v-theme-black-50));
  }
}
</style>
